import { type SetterOrUpdater, useRecoilState } from "recoil";

import { type BarMeasurement, barMeasurementsAtom } from "./barMeasurementsAtom";

export const useBarMeasurements = (): {
    barMeasurements: Record<number, BarMeasurement>;
    setBarMeasurements: SetterOrUpdater<Record<number, BarMeasurement>>;
} => {
    const [barMeasurements, setBarMeasurements] = useRecoilState(barMeasurementsAtom);
    return { barMeasurements, setBarMeasurements };
};
